export default [
  {
    path: '/banners',
    name: 'app-admin-banners',
    component: () => import('@/views/apps/banners/list/List.vue'),
    meta: {
      requiresAuth: true,
      action: 'read',
      resource: 'Vendedor',
      pageTitle: 'Banners',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Banners',
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-banners/:id?',
    name: 'app-admin-banners-add',
    component: () => import('@/views/apps/banners/edit/Edit.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Banners',
      action: 'update',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Listar ClienteFavoritos',
          active: false,
          to: {
            name: 'app-admin-banners',
          },
        },
        {
          text: 'Adicionar Produto',
          active: true,
        },
      ],
    },
  },
  {
    path: '/visualizar-banners/:id?',
    name: 'app-admin-banners-view',
    component: () => import('@/views/apps/banners/view/UsersView.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Banners',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Listar ClienteFavoritos',
          active: false,
          to: {
            name: 'app-admin-banners',
          },
        },
        {
          text: 'Visualizar Produto',
          active: true,
        },
      ],
    },
  },
]
